import store from '../../store/index.js'
export default {
	//留
	browerChange:{
		title:'深圳市中科卓软科技有限公司',
		keywords:'语言实验室,无线语言实验室,互联网语言实验室,同声传译,智慧教室,智慧教室互动,无纸化会议,多媒体教学,融合管控教学,智慧病房,护患通讯,信息对讲,床旁交互,护理白板,门旁信息,移动护理,病区管理平台',
		description:'专注于教育与医疗领域的产品服务,为学校及医院提供良好的服务保障',
		bottomMark:'深圳市中科卓软科技有限公司 保留所有权利 【粤ICP备15020506号】'
	},
	//留
	tabList: [{
			id: 1,
			name: '首页'
		},
		{
			id: 2,
			name: '关于我们'
		},
		{
			id: 3,
			name: '产品中心'
		},
		// {
		// 	id: 4,
		// 	name: '客户案例'
		// },
		// {
		// 	id: 5,
		// 	name: '新闻中心'
		// },
		{
			id: 6,
			name: '联系方式'
		},
	],
	
	//留  增加类型和修改类型，在这里改，2个js文件都需要修改
	product:{
		productChange:'点击了解',
		tabList:[{
				id: 1,
				name: '笔译口译'
			},{
				id: 2,
				name: '语言实验室'
			},{
				id: 3,
				name: '智慧校园'
			},{
				id: 4,
				name: '智慧病房'
			},{
				id: 5,
				name: '无纸化会议'
			},{
				id: 6,
				name: '电子教室'
			}]
	},
	
	//留
	bottom:{
		class1:{
			title:'首页',
			text1:'产品中心',
			text2:'关于我们',
			text3:'新闻中心',
		},
		class2:{
			title:'关于我们',
			text1:'公司简介',
			text2:'发展历程',
			text3:'资质荣誉',
			text4:'企业文化',
		},
		class3:{
			title:'产品中心',
			text1:'外语产品',
			text2:'智慧校园',
			text3:'智慧病房',
			text4:'无纸化会议',
		},
		class4:{
			title:'客户案例',
		},
		class5:{
			title:'新闻中心',
		},
		class6:{
			title:'联系我们',
		},
	},
	
	//留
	right:{
		weixin:'微信客服',
		salePhone:'销售电话',
		phone:{
			text:"联系我们"
		},
		opinion:{
			title:"提交反馈",
			text1:"姓名",
			input1:'请输入姓名',
			text2:"公司名称",
			input2:"请输入公司名称",
			text3:"手机号码",
			input3:"请输入手机号码",
			text4:"反馈内容",
			input4:"请输入内容",
			text5:"提交反馈",
			text6:"邮箱",
			input5:'请输入邮箱',
			text7:"销售二维码：",
			text8:"公众号二维码：",
			text9:"提交反馈中"
		}
	},
	
	//留
	aboutUs:{
		title:'关于我们',
		title2:'发展历程',
		title3:'资质荣誉',
		tabList: [{
				id: 1,
				name: '公司简介',
				img_on:require('@/assets/img/news/frame.png'),
				img_off:require('@/assets/img/news/frameHover.png'),
			},
			{
				id: 2,
				name: '资质荣誉',
				img_on:require('@/assets/img/news/honour.png'),
				img_off:require('@/assets/img/news/honourHover.png'),
			},
			{
				id: 3,
				name: '企业文化',
				img_on:require('@/assets/img/news/civilization.png'),
				img_off:require('@/assets/img/news/civilizationHover.png'),
			}
		],
		coreConcepts:{
			title:'核心理念',
			content:'服务，信任，共赢，创新',
			list:[{
				id:1,
				title:'我们的愿景',
				content:'专注于教育与医疗领域的产品服务'
			},
			{
				id:2,
				title:'我们的使命',
				content:'成就客户，成就品牌，成就员工'
			},
			{
				id:4,
				title:'企业价值观',
				content:'客户第一，尊重个人，诚信正直，团队协作、追求卓越'
			}]
		},
		
	},
	
	//留
	humanResources:{
		title:'人力资源',
		topList: [{
				id: 1,
				name: '招聘岗位'
			}
		],
		title2:'招聘职位',
		tableText1:'岗位职责',
		tableText2:'工作内容',
		tableText3:'工作时间',
		tableText4:'薪酬福利',
		tableText5:'职位名称:',
		tableText6:'学历:',
		tableText7:'薪酬:',
		tableText8:'发布时间:',
	},
	
	topImageUrl:{
		about:require('@/assets/img/topImage/zh1.webp'),
		product:require('@/assets/img/topImage/zh2.webp'),
		contact:require('@/assets/img/topImage/zh3.webp'),
	}
	
	
}